<h2 mat-dialog-title>{{'Comment on puzzle solution'|translate}}</h2>
<mat-dialog-content>{{'Write a small comment on why you puzzled like you did...'|translate}}</mat-dialog-content>
<textarea class="comment" placeholder="{{'Your comment'|translate}}" #commentArea></textarea>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>{{'Cancel'|translate}}</button>
  <button mat-button mat-dialog-close>{{'Ok'|translate}}</button>
</mat-dialog-actions>
